<template>
  <div>
    <div class="row">
      <div class="col-4 pl-1 pr-1 mt-2">
        <profile-image v-if="doctor.profileImage" :file-id="doctor.profileImage" :image-style="doctor.status == 'online' ? 'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 90px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: #18ce0f' : (doctor.status == 'inAppointment' ? 'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 90px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: darkorange':'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 90px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: #888')"></profile-image>
        <i class="fa fa-user-md text-center" v-if="!doctor.profileImage" style="
        background: #888;
        padding: 10px;
        border-radius: 50%;
        color: #fff;
        border: 4px solid;
        width: 90px;
        height: 90px;
        font-size: 3em;
      " :style="
        doctor.status == 'online'
          ? { borderColor: '#18ce0f' }
          : (doctor.status == 'inAppointment' ? { borderColor: 'darkorange' }:{borderColor: '#888'})
      "></i>
      </div>
      <div class="col-8">
        <h6 class="card-title mt-2">
          Dr. {{ doctor.firstName }} {{ doctor.lastName }}
        </h6>
        <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller">
          {{ doctor.specialityText || "--" }}
        </h6>
        <p class="card-text mb-0" v-if="doctor.registration.number">
          {{ $t("message.Reg No") }}: {{ doctor.registration.number }},
          {{ doctor.registration.city }}
        </p>
        <p class="card-text mb-0">{{ doctor.description || "--" }}</p>

        <div v-if="!hideBillingDetails" class="mb-2 mt-2" v-show="doctor.billingDetails.enabled && doctor.billingDetails.amount">
          <div>{{ $t("message.Consultation charges") }} </div>
          <div style="font-weight: 900;font-size: 1.5em;">
            <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
            {{ doctor.billingDetails.amount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "doctor-details",

  props: ["doctor", "hideBillingDetails"],
};
</script>

<style scoped>
h6 {
  text-transform: none;
}
</style>
